(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('s3'), require('q'), require('rest'), require('rest/interceptor/pathPrefix'), require('rest/interceptor/mime'), require('rest/interceptor/defaultRequest'), require('rest/interceptor/errorCode'), require('ramda'), require('through2'), require('vinyl'), require('gulp-util')) :
  typeof define === 'function' && define.amd ? define(['exports', 's3', 'q', 'rest', 'rest/interceptor/pathPrefix', 'rest/interceptor/mime', 'rest/interceptor/defaultRequest', 'rest/interceptor/errorCode', 'ramda', 'through2', 'vinyl', 'gulp-util'], factory) :
  factory((global.index.js = {}), global.s3, global.Q, global.rest, global.pathPrefix, global.mime, global.defaultRequest, global.errorCode, global.R, global.through, global.File, global.gulp_util)
}(this, function (exports, s3, Q, rest, pathPrefix, mime, defaultRequest, errorCode, R, through, File, gulp_util) { 'use strict';

  Q = ('default' in Q ? Q['default'] : Q);
  rest = ('default' in rest ? rest['default'] : rest);
  pathPrefix = ('default' in pathPrefix ? pathPrefix['default'] : pathPrefix);
  mime = ('default' in mime ? mime['default'] : mime);
  defaultRequest = ('default' in defaultRequest ? defaultRequest['default'] : defaultRequest);
  errorCode = ('default' in errorCode ? errorCode['default'] : errorCode);
  R = ('default' in R ? R['default'] : R);
  through = ('default' in through ? through['default'] : through);
  File = ('default' in File ? File['default'] : File);

  class Source {
    constructor (file, release, config) {
      this.file        = file;
      this.release     = release;
      this.config      = config;
      this.client      = this.createS3Client(config);
    }

    get remoteKey () {
      let release = this.release;
      return `libs/edools-school/${release.app}/${release.version}/${this.file.relative}`;
    }

    createS3Client (config) {
      return s3.createClient({
        s3Options: config.s3Options
      });
    }

    upload () {
      let deferred = Q.defer();
      let uploader = this.client.uploadFile({
        localFile: this.file.base + this.file.relative,
        s3Params: {
          Bucket: this.config.s3Options.bucket,
          Key: this.remoteKey,
          ACL: 'public-read'
        }
      });

      uploader.on('progress', () => {
        deferred.notify(uploader.progressAmount);
      });
      uploader.on('error', deferred.reject);
      uploader.on('end', deferred.resolve);

      return deferred.promise;
    }
  }

  function getDefaultHeaders(config) {
    return {
      Accept: 'application/vnd.edools.themes.v1+json',
      Authorization: `Token token=${config.token}`
  };
  }

  function restClient(config) {
    return rest.wrap(mime)
               .wrap(pathPrefix, { prefix: 'https://api.myedools.com' })
               .wrap(defaultRequest, { headers: getDefaultHeaders(config) })
               .wrap(errorCode, { code: 400 })
               .wrap(errorCode, { code: 404 })
               .wrap(errorCode, { code: 500 });
  }

  class ThemeClient {
    constructor (config) {
      this.client = restClient(config);
    }

    update (theme) {
      return this.client({
        method: 'PUT',
        path: `/themes/${theme.id}`,
        entity: { theme: theme },
        headers: { 'Content-Type': 'application/json' }
      });
    }
  }

  class ReleaseClient {
    constructor (config) {
      this.client = restClient(config);
    }

    getOne (release) {
      return this.client(`/apps/${release.app}/releases/${release.version}`);
    }

    getList (app) {
      return this.client(`/apps/${app}/releases`);
    }

    create (release) {
      return this.client({
        method: 'POST',
        path: `/apps/${release.app}/releases`,
        entity: { app_release: release },
        headers: { 'Content-Type': 'application/json' }
      });
    }

    update (release) {
      return this.client({
        method: 'PUT',
        path: `/apps/${release.app}/releases/${release.version}`,
        entity: { app_release: release },
        headers: { 'Content-Type': 'application/json' }
      });
    }

    remove (release) {
      return this.client({
        method: 'DELETE',
        path: `/apps/${release.app}/releases/${release.version}`
    });
    }
  }



  class Release {
    constructor (config) {
      Object.assign(this, { app: config.app });
      Object.assign(this, config.manifest);
      this.client       = new ReleaseClient(config);
    }

    save () {
      return this.exists()
        .then(() => this.client.update(this))
        .catch(() => this.client.create(this));
    }

    exists () {
      var deferred = Q.defer();

      this.client.getOne(this)
        .then(deferred.resolve)
        .catch(deferred.reject);

      return deferred.promise;
    }
  }



  class AppHandler {
    static deploy (config, files) {
      let release = new Release(config),
          sources = R.map(file => new Source(file, release, config), files);

      return Q.all(R.map(source => source.upload(), sources))
              .then(() => release.save());
    }
  }

  exports.AppHandler = AppHandler;

  class AppStream {
    static deploy (config) {
      return through.obj((file, enc, cb) => {
        AppHandler.deploy(config, [file])
          .then(() => cb(null, file))
          .catch((err) => {
            throw err;
          });
      });
    }

    static config (manifest) {
      return through.obj(
        function (file, enc, cb) {
          let [prop, extension] = file.relative.split('.');
          if(extension !== 'json') {
            throw new gulp_util.PluginError('epm', 'Config file must be a JSON');
          }

          manifest[prop] = JSON.parse(file.contents.toString());
          cb();
        },
        function (cb) {
          this.push(new File({
            path: 'manifest.json',
            contents: new Buffer(JSON.stringify(manifest))
          }));
          cb();
        }
      );
    }
  }

  exports.AppStream = AppStream;

  class Theme {
    constructor (config) {
      this.id = config.id;
      this.package_url = config.package_url;
      this.client = new ThemeClient(config);
      this.schooljs_version = config.dependencies.bamboo;
    }

    deploy (dependencies) {
      this.dependencies = dependencies;
      return this.client.update(this);
    }
  }

  class DepsResolver {
    constructor (config) {
      this.releaseClient = new ReleaseClient(config);
    }

    resolve (dependencies) {
      return this.getDeps(dependencies)
        .then(deps => this.format(deps));
    }

    getDeps (dependencies) {
      dependencies = this.depsToArray(dependencies)
        .filter(dep => dep.app !== 'bamboo');

      return Q.all(R.map(dep => {
        return this.releaseClient.getOne(dep)
          .then(res => res.entity);
      }, dependencies));
    }

    depsToArray (dependencies) {
      return R.map(key => {
        return { app: key, version: dependencies[key] };
      }, R.keys(dependencies));
    }

    format (dependencies) {
      dependencies = R.concat(dependencies, this.getSubDeps(dependencies));

      return R.reduce((acc, dep) => {
        acc[dep.app || dep.name] = dep.version;
        return acc;
      }, {}, dependencies);
    }

    getSubDeps (dependencies) {
      let subDeps = R.reduce((acc, dep) => {
        return R.concat(acc, this.depsToArray(dep.dependencies));
      }, [], dependencies);

      subDeps = R.uniqWith((dep1, dep2) => dep1.app === dep2.app, subDeps);
      subDeps = R.filter(subDep => !R.contains(subDep.app, R.map(R.prop('name'), dependencies)), subDeps);
      return subDeps;
    }
  }



  class ThemeHandler {
    static deploy (config) {
      let theme = new Theme(config),
        depsResolver = new DepsResolver(config);

      return depsResolver.resolve(config.dependencies)
        .then(dependencies => theme.deploy(dependencies))
        .catch((err) => {
          throw err;
        });
    }
  }

  exports.ThemeHandler = ThemeHandler;



}));
